import { render, staticRenderFns } from "./TextDisplayDropdown.vue?vue&type=template&id=c8d0b428&scoped=true&"
import script from "./TextDisplayDropdown.vue?vue&type=script&lang=js&"
export * from "./TextDisplayDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TextDisplayDropdown.vue?vue&type=style&index=0&id=c8d0b428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d0b428",
  null
  
)

export default component.exports